import getBasePath from '../../../../../common/functions/api-resource';

const basePath = getBasePath('usuario', 'transferencia-definitiva');

const transferenciaPosseActions = {
  listarFuncionarios: { method: 'GET', url: `${basePath}/funcionario` },
  listarCarteiras: { method: 'GET', url: `${basePath}/carteira-cliente?{&id_regiao*}{&id_cliente*}{&id_holding*}` },
  listarResponsaveis: { method: 'GET', url: `${basePath}/responsavel-faturamento?{&id_regiao*}{&id_cliente*}{&id_holding*}` },
  orcamento: { method: 'GET', url: `${basePath}/orcamentos?{&marcas*}` },
  transferir: { method: 'POST', url: `${basePath}` },
  listar: { method: 'GET', url: `${basePath}?tamanhoPagina={tamanhoPagina}&numeroPagina={numeroPagina}` },
};

export default resource => resource(`${basePath}`, {}, transferenciaPosseActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/controlador-trade/transferencia-posse-definitiva.js